import * as _ from 'lodash';
import moment from 'moment';
import * as display from './display';
import * as validate from './validate';
import * as language from './language';
import * as localStorage from './localStorage';
import * as jwt from './jwt'
import * as addon from './addon'
import * as data from './data'
import * as clipboard from './clipboard'
import * as  stream from './stream'

export default defineNuxtPlugin((nuxtApp: any) => {
  return {
    provide: {
      _,
      moment,
      functions: {
        notify: {
          success: (props: any) => {
            props.group = 'tailwind';
            props.data = {
              ...props,
            };
            nuxtApp.$notify(props);
          },
          error: (props: any) => {
            props.group = 'tailwind';
            props.data = {
              ...props,
              isError: true,
            };
            nuxtApp.$notify(props);
          },
          info: (props: any) => {
            props.group = 'tailwind';
            props.data = {
              ...props,
              isNotice: true
            };
            nuxtApp.$notify(props);
          },
        },
        ...validate,
        ...display,
        ...language,
        ...localStorage,
        ...jwt,
        ...addon,
        ...data,
        ...clipboard,
        ...stream,
      },
    },
  };
});
